import React from "react";
import { View, StyleSheet } from "react-native";
import { ShimmerBox } from "../../../components/skeletons";

const CourseHealthCardSkeleton: React.FC = () => (
  <View style={styles.courseCard}>
    <View style={styles.courseCardHeader}>
      <View style={{ flex: 1, gap: 8 }}>
        <ShimmerBox width="75%" height={16} borderRadius={6} />
        <ShimmerBox width="45%" height={12} borderRadius={6} />
      </View>
    </View>
    <View style={styles.courseCardStats}>
      {[0, 1, 2].map((i) => (
        <View key={i} style={{ gap: 6 }}>
          <ShimmerBox width={50} height={11} borderRadius={6} />
          <ShimmerBox width={36} height={24} borderRadius={6} />
        </View>
      ))}
      <ShimmerBox width={16} height={16} borderRadius={4} style={{ marginLeft: "auto" }} />
    </View>
  </View>
);

const styles = StyleSheet.create({
  courseCard: {
    width: "48%",
    backgroundColor: "rgba(255,255,255,0.6)",
    borderRadius: 32,
    padding: 24,
    borderWidth: 1,
    borderColor: "#EAECF0",
    minHeight: 164,
    justifyContent: "space-between",
  },
  courseCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 16,
  },
  courseCardStats: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
  },
});

export default CourseHealthCardSkeleton;
